// Home.js
import React from 'react';
import './home.css';
import Social from './Social';
import Data from './Data';
import ScrollDown from './ScrollDown';

const Home = ({ isDarkMode }) => {
    const bodyClass = `home section ${isDarkMode ? "dark-mode" : ""}`;

    return (
        <section className={bodyClass} id="home">
            <div className="home__container container grid">
                <div className="home__content grid">
                    <Social isDarkMode={isDarkMode} />
                    <div className="home__img"></div>
                    <Data isDarkMode={isDarkMode}  />
                </div>
                <ScrollDown isDarkMode={isDarkMode}/>
            </div>
        </section>
    );
};

export default Home;
